// extracted by mini-css-extract-plugin
export default {"cardContent":"ResumenMetricas_cardContent__m4HuV","icon":"ResumenMetricas_icon__nvK73","resumen-general":"ResumenMetricas_resumen-general__NkTKS"};